<template>
  <div class="admin-list">
    <div class="card">
      <div class="header mb-30">管理员</div>
      <div style="display:flex;">
        <img src="@/assets/admin_icon.png" class="admin-icon" alt="管理员" />
        <div>
          <div class="staff-count-box">
            <div class="staff-count">{{ admins.length }}</div>
            <div class="label">就职人数</div>
          </div>
          <div>
            <span class="label">备注：</span><!--
            --><span style="color: #131d2d">拥有操控权限系统的功能</span>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div>
        <div class="list-header-container">
          <div class="header">管理员列表</div>
          <el-button v-if="isSuperAdmin" @click="openAddDialog" plain class="add-btn">
            <i class="mdg-icon ico_creatx text-primary vcenter"></i>
            <span class="vcenter">添加</span>
          </el-button>
        </div>
        <el-table :data="admins" stripe :max-height="650" class="staff-table">
          <el-table-column
            v-for="column in columns" :key="column.key"
            :align="column.key === 'index' ? 'center' : 'left'" show-overflow-tooltip
            :prop="column.key" :label="column.label" :width="column.width"
          ></el-table-column>
          <el-table-column
            align="left" show-overflow-tooltip :width="isSuperAdmin ? 150 : null"
            prop="isSuperAdmin" label="超级管理员"
          >
            <template slot-scope="scope">
              {{ scope.row.isSuperAdmin ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column v-if="isSuperAdmin" label="操作" align="left">
            <template slot-scope="scope">
              <el-button
                v-if="admins[scope.$index].isSuperAdmin"
                @click="openTransferDialog"
                style="padding: 0 !important" type="text"
              >
                <span class="text-primary">移交</span>
              </el-button>
              <el-button
                v-else @click="removeAdmin(scope.$index)"
                style="padding: 0 !important" type="text"
              >
                <span class="text-danger">删除</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      :visible.sync="addDialogShown" title="添加管理员"
      width="800px" :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <div style="display:flex; float:right;" class="mb-15">
          <el-input
            v-model="keyword" placeholder="搜索手机号/姓名/账号名"
            @keyup.enter.native="searchStaffs" style="width:264px"
          ></el-input>
          <el-button @click="searchStaffs" type="primary" class="search-btn">
            <i class="mdg-icon ico_searchx text-white" alt="搜索" />
          </el-button>
        </div>
        <el-table
          :data="staffs" stripe :max-height="650" class="staff-table"
          @selection-change="selectionChange"
        >
          <el-table-column width="60" align="center" type="selection"></el-table-column>
          <el-table-column
            v-for="column in staffColumns" :key="column.key"
            align="left" show-overflow-tooltip :width="column.width"
            :prop="column.key" :label="column.label"
          ></el-table-column>
        </el-table>
        <div class="text-right mt-15">
          <el-pagination
            class="px-0" background
            layout="prev, pager, next, sizes"
            @current-change="onPageChange"
            @size-change="onPageSizeChange"
            :current-page="query.page"
            :page-size="query.pageSize"
            :page-sizes="[10, 20, 50, 70, 100, 150, 200, 300, 500]"
            :total="query.total"
          ></el-pagination>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button @click="submitAddDialog" type="primary" size="small" class="action-btn">
          确定
        </el-button>
        <el-button @click="closeAddDialog" type="default" size="small" class="action-btn">
          取消
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="transferDialogShown" title="移交超级管理员"
      width="600px" :close-on-click-modal="false"
    >
      <div class="dialog-body">
        <el-form
          :model="transferForm" :rules="transferFormRules"
          ref="transferForm" label-width="125px"
        >
          <el-form-item label="新超级管理员" prop="selected" required>
            <el-select v-model="transferForm.selected" placeholder="请选择" style="width:350px">
              <el-option
                v-for="item in transferForm.staffs" :key="item.id"
                :label="item.name" :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原管理员手机号" required>
            <div>{{ transferForm.mobilePhone }}</div>
          </el-form-item>
          <el-form-item label="验证码" prop="verificationCode" required class="mb-0">
            <el-input
              v-model.trim="transferForm.verificationCode"  style="width:350px"
              placeholder="请输入4位短信验证码" class="sms-code-input"
            >
              <el-button
                slot="suffix" @click="sendVerificationCode"  type="text"
                :loading="transferForm.queryCodeLoading" class="sms-code-btn"
                :disabled="transferForm.timeCount !== 0"
              >
                <span v-if="transferForm.queryCodeLoading">发送中</span>
                <span v-else-if="transferForm.timeCount === 0">
                  {{ transferForm.queryCodeFirstTime ? '获取短信验证码' : '重发短信验证码' }}
                </span>
                <span v-else>{{ transferForm.timeCount }} 秒</span>
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button @click="submitTransferDialog" type="primary" size="small" class="action-btn">
          确定
        </el-button>
        <el-button @click="closeTransferDialog" type="default" size="small" class="action-btn">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  Button, Dialog, Input,
  Table, TableColumn, Pagination,
  Form, FormItem, Select, Option,
} from 'element-ui'
import * as API from '@/api/admin'
import { find as findStaffs } from '@/api/staff'

const PAGE_SIZE = 10

export default {
  name: 'admin-list',
  components: {
    ElButton: Button,
    ElDialog: Dialog,
    ElInput: Input,
    ElTable: Table,
    ElTableColumn: TableColumn,
    ElPagination: Pagination,
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
  },
  data() {
    return {
      admins: [],
      columns: [{
        key: 'index',
        label: '序号',
        width: 60,
      }, {
        key: 'username',
        label: '账号名',
        width: 150,
      }, {
        key: 'name',
        label: '姓名',
        width: 150,
      }, {
        key: 'mobilePhone',
        label: '手机号码',
        width: 150,
      }],
      addDialogShown: false,
      keyword: '',
      query: {
        page: 1,
        pageSize: PAGE_SIZE,
        total: 0,
        totalPages: 1,
        keyword: '',
      },
      staffs: [],
      selected: [],
      staffColumns: [{
        key: 'index',
        label: '序号',
        width: 70,
      }, {
        key: 'username',
        label: '账号名',
      }, {
        key: 'name',
        label: '姓名',
      }, {
        key: 'mobilePhone',
        label: '手机号码',
      }],
      transferDialogShown: false,
      transferForm: {
        staffs: [],
        selected: null,
        mobilePhone: '',
        verificationCode: '',
        timeCount: 0,
        queryCodeFirstTime: true,
        queryCodeLoading: false,
      },
      transferFormRules: {
        selected: [{ required: true, message: '请选择新管理员' }],
        verificationCode: [
          { required: true, message: '请输入4位短信验证码' },
          { pattern: /^[0-9]{4}$/, message: '请输入4位短信验证码' },
        ],
      },
    }
  },
  computed: {
    isSuperAdmin() {
      if (_.isEmpty(this.admins)) {
        return false
      }
      const userId = parseInt(this.$store.state.userInfo.userid, 10)
      return this.admins.some(item => item.isSuperAdmin && item.id === userId)
    },
  },
  async mounted() {
    await this.findAdmins()
  },
  methods: {
    async findAdmins() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      this.admins = await API.findAdmins()
      loading.close()
    },
    async openTransferDialog() {
      this.transferForm.selected = null
      this.transferForm.mobilePhone = this.$store.state.userInfo.mobile
      this.transferForm.verificationCode = ''

      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const data = await findStaffs({
        page: 1,
        pageSize: 99999,
      })
      const userId = parseInt(this.$store.state.userInfo.userid, 10)
      this.transferForm.staffs = data.results.filter(
        item => item.id !== userId,
      )
      loading.close()

      this.transferDialogShown = true

      this.$nextTick(() => {
        this.$refs.transferForm.clearValidate()
      })
    },
    closeTransferDialog() {
      this.transferDialogShown = false
    },
    async submitTransferDialog() {
      this.$refs.transferForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        try {
          await this.$confirm('确定要移交超级管理员吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          const params = _.pick(this.transferForm, [
            'selected', 'verificationCode',
          ])
          const loading = this.$loading({
            lock: true,
            text: '加载中...',
          })
          const flag = await API.transferSuperAdmin(params)
          loading.close()
          if (flag) {
            this.$message({
              type: 'success',
              message: '移交成功',
            })
            this.transferDialogShown = false
            await this.findAdmins()
          }
        } catch (e) {
          // noop
        }
      })
    },
    async sendVerificationCode() {
      this.transferForm.queryCodeLoading = true
      const flag = await API.sendVerificationCode()
      this.transferForm.queryCodeLoading = false
      if (flag) {
        this.transferForm.timeCount = 60
        this.transferForm.queryCodeFirstTime = false
        const interval = setInterval(() => {
          this.transferForm.timeCount -= 1
          if (this.transferForm.timeCount === 0) {
            clearInterval(interval)
          }
        }, 1000)
      }
    },
    async openAddDialog() {
      this.addDialogShown = true
      this.keyword = ''
      this.query = {
        page: 1,
        pageSize: PAGE_SIZE,
        total: 0,
        totalPages: 1,
        keyword: '',
      }
      await this.findStaffs()
    },
    closeAddDialog() {
      this.addDialogShown = false
    },
    async submitAddDialog() {
      if (_.isEmpty(this.selected)) {
        this.$message({
          type: 'error',
          message: '没有选中任何职员',
        })
        return
      }

      try {
        await this.$confirm('确定要将这些职员添加为管理员吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        const flag = await API.add({
          ids: this.selected.map(item => item.id),
        })
        loading.close()
        if (flag) {
          this.$message({
            type: 'success',
            message: '添加成功',
          })
          await this.findAdmins()
          this.addDialogShown = false
        }
      } catch (e) {
        // noop
      }
    },
    async removeAdmin(index) {
      const admin = this.admins[index]
      try {
        await this.$confirm(`确定要删除管理员 ${admin.name} 吗？`, '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
        })
        const flag = await API.remove({ id: admin.id })
        loading.close()
        if (flag) {
          this.$message({
            type: 'success',
            message: '删除成功',
          })
          await this.findAdmins()
        }
      } catch (e) {
        // noop
      }
    },
    async findStaffs() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      const data = await API.findExternalStaffs(this.query)
      loading.close()
      this.query = Object.assign(this.query, _.pick(data, [
        'page', 'pageSize', 'total', 'totalPages',
      ]))
      this.staffs = data.results
    },
    selectionChange(selection) {
      this.selected = _.intersectionWith(this.staffs, selection, (a, b) => {
        let flag = true
        const keys = Object.keys(b)
        for (let i = 0; i < keys.length; i += 1) {
          const key = keys[i]
          if (b[key] !== a[key]) {
            flag = false
            break
          }
        }
        return flag
      })
    },
    async searchStaffs() {
      this.query.keyword = this.keyword || ''
      this.query.page = 1
      await this.findStaffs()
    },
    async onPageChange(page) {
      this.query.page = page
      await this.findStaffs()
    },
    async onPageSizeChange(pageSize) {
      this.query.page = 1
      this.query.pageSize = pageSize
      await this.findStaffs()
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  padding: 20px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(53,129,251,0.1);
  border-radius: 2px;
}
.header {
  color: #131d2d;
  font-size: 20px;
  line-height: 28px;
  font-weight: bold;
}
.admin-icon {
  width: 96px;
  height: 96px;
  margin-right: 34px;
}
.label {
  color: #6f83a1;
  line-height: 20px;
  font-weight: bold;
}
.staff-count-box {
  margin-bottom: 14px;
  width: 56px;
  text-align: center;
}
.staff-count {
  color: #131d2d;
  font-size: 24px;
  line-height: 33px;
  font-weight: bold;
}
.divider {
  width: 100%;
  height: 1px;
  background: #d3d9e2;
  margin: 43px 0 35px;
}
.list-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}
.add-btn {
  padding: 0 11px !important;
  .mdg-icon {
    margin-right: 6px;
    font-size: 24px;
  }
}
.search-btn {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: !important;
  padding: 0 !important;
  width: 36px;
  height: 36px;
  line-height: 32px;
  text-align: center;
  margin-left: -2px;
  z-index: 100;
  i.mdg-icon {
    font-size: 20px;
  }
}
.dialog-body {
  padding: 20px 32px;
}
.dialog-footer {
  padding: 20px 0 40px;
  text-align: center;
  .action-btn {
    width: 106px;
    &:not(:first-child) {
      margin-left: 12px;
    }
  }
}
</style>
